import React from "react";
import { Flag } from "./types";

const Context = React.createContext<{
  ref: React.MutableRefObject<HTMLDivElement | null>;
  flags: Flag[];
  registerFlag(flag: Flag): void;
  removeFlag(name: string): void;
}>({
  ref: React.createRef(),
  flags: [],
  registerFlag(flag) {},
  removeFlag(flag) {},
});

function useInfiniteScroll() {
  const { ref } = React.useContext(Context);

  return ref;
}

export { Context, useInfiniteScroll };
